module.exports = __webpack_public_path__ + "img/证书1.dc94e59a.jpg";